import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58a39f84")

_pushScopeId("data-v-58a39f84")
const _hoisted_1 = { class: "detail-ingredient-item-area" }
const _hoisted_2 = { class: "detail-ingredient-item-value-view" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetailIngredientSubItem = _resolveComponent("DetailIngredientSubItem")

  return (_openBlock(), _createBlock("div", {
    class: "detail-ingredient-item",
    style: _ctx.styleItem
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: "detail-ingredient-item-name-view",
        style: { color: _ctx.getLabelColor() }
      }, [
        _createVNode("div", { innerHTML: _ctx.description }, null, 8, ["innerHTML"])
      ], 4),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", { innerHTML: _ctx.quantity }, null, 8, ["innerHTML"])
      ])
    ]),
    _withDirectives(_createVNode("div", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getIngredientSubItems(), (item) => {
        return (_openBlock(), _createBlock(_component_DetailIngredientSubItem, {
          key: item.id,
          description: item.item.description,
          quantity: item.item.quantityText,
          isShowDialog: _ctx.isShowDialog
        }, null, 8, ["description", "quantity", "isShowDialog"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512), [
      [_vShow, _ctx.isShowSubItem()]
    ])
  ], 4))
})